import { styled, css } from 'styled-components';
import { Media } from '../../../../../theme/Media';
import { BORDER_RADIUS, CSS_VAR_VISIBLE_WIDTH, DATA_ATTR_HAS_HORIZONTAL_SCROLLBAR, GROUP_INDICATOR_WIDTH, GROUP_SPACING, Z_INDEX_GROUP_HEADER, Z_INDEX_GROUP_INDICATOR, } from '../../constants';
import { RowWrapper } from '../Row/styled';
export const GroupHeaderWrapper = styled.div `
  width: fit-content;
  display: flex;
  align-items: center;
  gap: 8px;
  overflow: hidden;
  position: relative;
  z-index: ${Z_INDEX_GROUP_HEADER};
  background: ${({ theme }) => theme.colors.grey00_1};
  ${({ theme }) => theme.typography.textMedium};
  color: ${({ theme }) => theme.colors.grey100_1};
  border-top-left-radius: ${BORDER_RADIUS};
  border-top-right-radius: ${BORDER_RADIUS};

  padding: ${({ $hasActions }) => {
    const right = $hasActions ? '12px' : '24px';
    return `4px ${right} 2px 24px`;
}};

  &::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: ${GROUP_INDICATOR_WIDTH};
    background: ${({ theme }) => theme.colors.lightBlue30};
    border-top-left-radius: ${BORDER_RADIUS};
    z-index: ${Z_INDEX_GROUP_INDICATOR};
  }

  ${({ $inner }) => $inner &&
    css `
      border: 1px solid ${({ theme }) => theme.colors.grey10_1};
      border-bottom: none;
      margin-bottom: -1px;
    `}

  @media ${Media.smMin} {
    grid-column: 1 / -1;
    position: sticky;
    left: 0;
    max-width: calc(var(${CSS_VAR_VISIBLE_WIDTH}) - ${GROUP_INDICATOR_WIDTH});

    ${({ $inner }) => $inner &&
    css `
        left: -1px;
        margin-left: -1px;
      `}
  }

  @media ${Media.xsMax} {
    max-width: calc(100% - ${GROUP_INDICATOR_WIDTH});
  }
`;
export const GroupWrapper = styled.div `
  position: relative;

  @media ${Media.smMin} {
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;

    // Each row owns both its borders; adjacent rows overlap into a single line
    // so a row being dragged (visibility: hidden) leaves a slot whose top and
    // bottom edges are still painted by the neighbors. Mirrors StyledGrid.
    & > ${RowWrapper} {
      border-top: 1px solid ${({ theme }) => theme.colors.grey10_1};
      border-bottom: 1px solid ${({ theme }) => theme.colors.grey10_1};
    }

    & > ${RowWrapper} + ${RowWrapper} {
      margin-top: -1px;
    }

    ${({ $inner }) => $inner
    ? css `
            & > ${RowWrapper} {
              border-radius: 0;
            }
          `
    : css `
            & > ${RowWrapper}:first-of-type {
              border-top: none;
            }

            & > ${RowWrapper}:last-child {
              border-bottom: none;
            }

            & > ${GroupHeaderWrapper} + ${RowWrapper} {
              border-top-right-radius: ${BORDER_RADIUS};
            }

            & > ${RowWrapper}:last-child {
              border-bottom-right-radius: ${BORDER_RADIUS};
              border-bottom-left-radius: ${BORDER_RADIUS};
            }
          `}

    [${DATA_ATTR_HAS_HORIZONTAL_SCROLLBAR}='true'] &:last-child > ${RowWrapper}:last-child {
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
    }
  }

  @media ${Media.xsMax} {
    display: flex;
    flex-direction: column;
    margin: ${GROUP_SPACING} 0;

    & + & {
      margin-top: 0;
    }

    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }

    & > ${RowWrapper} {
      position: relative;
      border-radius: 0 ${BORDER_RADIUS} ${BORDER_RADIUS} ${BORDER_RADIUS};
      margin-top: 0;

      ${({ theme, $inner }) => $inner
    ? css `
              border: 1px solid ${theme.colors.grey10_1};
            `
    : theme.shadows.small}
    }

    & > ${RowWrapper} + ${RowWrapper} {
      margin-top: ${GROUP_SPACING};
      border-radius: ${BORDER_RADIUS};

      ${({ theme, $inner }) => $inner
    ? css `
              border: 1px solid ${theme.colors.grey10_1};
            `
    : theme.shadows.small}
    }
  }
`;
const titleEllipsis = css `
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  min-width: 0;
`;
export const Title = styled.span `
  ${titleEllipsis}
`;
export const ClickableTitle = styled.span `
  cursor: pointer;
  ${titleEllipsis}
`;
